export default __webpack_public_path__ + "static/media/maps-and-flags.a63f8022.svg";